import { Builder, withChildren } from '@builder.io/react';
import Section from './section';
import theme from '../../gatsby-plugin-theme-ui-v1';

Builder.registerComponent(withChildren(Section), {
  name: 'Section',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'string',
      enum: Object.keys(theme.backgroundColors),
      defaultValue: 'transparent',
    },
    {
      name: 'backgroundColorOverride',
      type: 'color',
      advanced: true,
      required: false,
    },
    {
      name: 'sectionSize',
      type: 'string',
      enum: [...Object.keys(theme.space), 'viewHeight100', 'aspect'],
      defaultValue: 'large',
    },
    {
      name: 'backgroundMedia',
      type: 'string',
      enum: ['none', 'image', 'video'],
      defaultValue: 'none',
    },
    {
      name: 'backgroundImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
      required: false,
      showIf: (options) => options.get('backgroundMedia') === 'image',
    },
    {
      name: 'backgroundVideo',
      helperText:
        'Must be an MP4 Video URL, e.g. https://player.vimeo.com/external/332661286.hd.mp4',
      type: 'url',
      required: false,
      showIf: (options) => options.get('backgroundMedia') === 'video',
    },
    {
      name: 'mediaObjectFit',
      type: 'string',
      advanced: true,
      enum: ['contain', 'cover', 'fill', 'none', 'scaled-down'],
      helperText: 'https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit',
      defaultValue: 'cover',
      required: true,
      showIf: (options) => options.get('backgroundMedia') !== 'none',
    },
    {
      name: 'mediaObjectPosition',
      type: 'string',
      advanced: true,
      helperText:
        'https://developer.mozilla.org/en-US/docs/Web/CSS/object-position',
      defaultValue: 'center',
      required: true,
      showIf: (options) => options.get('backgroundMedia') !== 'none',
    },
    {
      name: 'aspectWidth',
      type: 'number',
      defaultValue: 16,
      showIf: (options) => options.get('sectionSize') === 'aspect',
    },
    {
      name: 'aspectHeight',
      type: 'number',
      defaultValue: 9,
      showIf: (options) => options.get('sectionSize') === 'aspect',
    },
    {
      name: 'fullWidthContainer',
      type: 'boolean',
      defaultValue: false,
      helperText:
        'Inner wrapper extends all the way to the edge of the browser window.',
    },
    {
      name: 'gridGap',
      type: 'string',
      enum: Object.keys(theme.space),
      defaultValue: 'none',
    },
    {
      name: 'gridColumnOverride',
      type: 'number',
      advanced: true,
      helperText:
        'Grid Columns deafults to the number of Boxes, this setting will force a new number of columns.',
    },
  ],

  // childRequirements: {
  //   message: 'You can only put Block, Columns, or Custom Code in Sections',
  //   query: {
  //     'component.name': { $in: [
  //       'Block', 
  //       'Columns',
  //       'Custom Code',
  //     ] },
  //   },
  // },

  // defaultChildren: [
  //   {
  //     "@type": "@builder.io/sdk:Element",
  //     component: {
  //       name: "Block",
  //       options: {
  //         padding: "small",
  //         backgroundColor: "red30"
  //       }
  //     },
  //     children: [
  //       {
  //         "@type": "@builder.io/sdk:Element",
  //         component: {
  //           name: "Text",
  //           options: {
  //             text: "Placeholder Text Goes Here",
  //             alignText: "Center",
  //           },
  //         },
  //       }
  //     ]
  //   },
  // ],
});
